import { createSlice } from '@reduxjs/toolkit';
import { createPlaidLinkToken, exchangePublicToken, updatePlaidLinkToken } from './actions';

type InitialStatePlaidProps = {
  linkToken: string | null;
  isPlaidLoginRequired: boolean;
  isLoading: boolean;
};

const initialState: InitialStatePlaidProps = {
  linkToken: null,
  isPlaidLoginRequired: false,
  isLoading: false,
};

export const plaidSlice = createSlice({
  name: 'plaid',
  initialState,
  reducers: {
    setIsPlaidLoginRequired: (state, action) => {
      state.isPlaidLoginRequired = action.payload;
    },
    clearState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createPlaidLinkToken.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createPlaidLinkToken.fulfilled, (state, action) => {
      state.linkToken = action.payload.linkToken;
      state.isLoading = false;
    });
    builder.addCase(createPlaidLinkToken.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(updatePlaidLinkToken.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updatePlaidLinkToken.fulfilled, (state, action) => {
      state.linkToken = action.payload.linkToken;
      state.isLoading = false;
    });
    builder.addCase(updatePlaidLinkToken.rejected, (state) => {
      state.isLoading = false;
    });

    builder.addCase(exchangePublicToken.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(exchangePublicToken.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(exchangePublicToken.rejected, (state) => {
      state.isLoading = false;
    });
  },
  selectors: {
    selectLinkToken: (state) => state.linkToken,
    selectIsLoading: (state) => state.isLoading,
    selectIsPlaidLoginRequired: (state) => state.isPlaidLoginRequired,
  },
});

export const { clearState, setIsPlaidLoginRequired } = plaidSlice.actions;
export const { selectLinkToken, selectIsLoading, selectIsPlaidLoginRequired } =
  plaidSlice.selectors;
